import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Store} from "@ngxs/store";
import {AuthState} from "../../states/auth.state";
import {AuthenticationService} from "../../service/auth.service";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const tokens = this.authenticationService.getTokens();
    if (tokens) {

      // Get token data
      const token = this.authenticationService.obtainDecodedAuthToken()

      // Check two factor auth
      if(token && token.token.user.using2FA){
        // Check access code
        if(token.verifyAccessCode) {
          return true
        } else {

          // Redirect to 2FA code screen
          this.router.navigate(['/account/2fa'], { queryParams: { returnUrl: state.url } });
          return false
        }
      } else {
        // logged in so return true
        return true;
      }
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

}
